/**
 * Prins: Components / Drawer (modify Shared)
 *
 * @copyright 2023 i-fabrik GmbH
 * @author Heiko Pfefferkorn
 */

import {getElementFromSelector} from '@ifabnpm/bootstrap/utils.js';

import SelectorEngine from '@ifabnpm/bootstrap/dom/selector-engine.js';
import EventHandler from '@ifabnpm/bootstrap/dom/event-handler.js';
import Manipulator from '@ifabnpm/bootstrap/dom/manipulator.js';

import Drawer from '@ifabnpm/bootstrap/component/drawer.js';

// -------
// Private
// -------

// ------
// Public
// ------

/**
 * Initialisierung.
 */
const init = () => {
	const toggles = SelectorEngine.find('[data-toggle-drawer]');

	if (toggles.length) {
		for (const toggle of toggles) {
			const target = getElementFromSelector(toggle);

			if (target) {
				const drawer = new Drawer(target, {
					onShow: (event) => {
						if (event.trigger) {
							Manipulator.addClass(event.trigger, '_active');
						}
					},
					onHidden: (event) => {
						if (event.trigger) {
							Manipulator.removeClass(event.trigger, '_active');
						}
					}
				});

				EventHandler.on(toggle, 'click.ifab.drawer', (event) => {
					event.preventDefault();

					drawer.toggle();
				});
			}
		}
	}
};

// Export
export default {
	init: init
};
